import useCategory from '../../hooks/useCategory';

import TaxonomyPage, { TaxonomyPageProps } from './TaxonomyPage';

interface CategoryPageProps extends TaxonomyPageProps {
    slug: string;
}

function CategoryPage({ slug, ...props }: CategoryPageProps) {
    const { category = null, notFound = false } = useCategory(slug);

    return <TaxonomyPage taxonomy={category} notFound={notFound} {...props} />;
}

export default CategoryPage;
